import { RestApiResultVoucherWithStats, VoucherWithStats } from '@flipdish/api-client-typescript';
import axios from 'axios';

import { getApiEndPoint } from '../../helpers/apibase';
import { mapServerError } from '../../services/utils/serverErrorMapper';

const baseUrl = getApiEndPoint();
const portalApi = axios.create({
  baseURL: baseUrl,
  withCredentials: true,
});

// #region getVoucherById
export type GetByIdProps = {
  voucherId: number;
};
export async function getById({ voucherId }: GetByIdProps): Promise<VoucherWithStats> {
  try {
    const msg = await portalApi.get<RestApiResultVoucherWithStats>(
      `/api/v1.0/vouchers/${encodeURIComponent(voucherId.toString())}`
    );

    return {
      ...msg.data.Data,
      // HACK: This is a hack to fix the date parsing timezone issue to always be UTC noon
      // This is a workaround to ensure that the date is parsed correctly in the client
      ExpiryDate: (() => {
        const d = new Date(msg.data.Data.ExpiryDate + 'Z');
        return new Date(Date.UTC(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate(), 12, 0, 0, 0));
      })(),
      // We need to parse the start date as a UTC date
      StartDate: new Date(msg.data.Data.StartDate + 'Z'),
    };
  } catch (e) {
    const err = await mapServerError(e);
    throw err;
  }
}
// #endregion
